export const CYCLES = {
  "preliminary-checks": "Contrôles Préliminaires",
  "financing-and-treasury-cycle": "Cycle Financement et Trésorerie",
  "supplier-cycle": "Cycle Fournisseurs",
  "clients-cycle": "Cycle Clients",
  "other-accounts-cycle": "Cycle Autres Comptes",
  "cycle-asset": "Cycle Immobilisations",
  "tax-cycle": "Cycle Taxes",
  "equity-cycle": "Cycle Capitaux Propres",
  "brochures-cycle": "Mise à Disposition des Comptes Sociaux"
};

export const CYCLES_LOOKUP = Object.fromEntries(
  Object.entries(CYCLES).map(([urlName, cycleName]) => {
    return [cycleName, urlName];
  })
);
